import React from 'react';
import ReactDom from 'react-dom';
import { BrowserRouter } from "react-router-dom";
import {RecoilRoot} from "recoil";

import App from "./components/App";

import './styles.scss';

ReactDom.render((
    <BrowserRouter>
        <RecoilRoot>
            <App />
        </RecoilRoot>
    </BrowserRouter>
    ) ,document.querySelector('#app'));